// AJAX Pagination

// Init variables
const bottomActionLink = document.querySelector('.blog-bottom-actions a');
let template = bottomActionLink.dataset.template;
let page_number = parseInt(bottomActionLink.dataset.page);
let max_pages = parseInt(bottomActionLink.dataset.maxpages);
let ajax_tag = bottomActionLink.dataset.tag;


document.querySelector('.blog-bottom-actions a').addEventListener('click', function (e) {
  console.log('ACTION BOTTOM CLICK');
  e.preventDefault();
  document.querySelector('.articles-list .loader').classList.add('active');

  let ajax_url;
  if (template === 'load') {
    // Index Template
    ajax_url = '/blogs/' + e.target.dataset.handle + '?view=' + template + page_number;
  } else {
    // Blog Template
    if (ajax_tag) {
      ajax_url = '/blogs/' + e.target.dataset.handle + '/tagged/' + ajax_tag + '?page=' + page_number + '&view=' + template;
    } else {
      ajax_url = '/blogs/' + e.target.dataset.handle + '?page=' + page_number + '&view=' + template;
    }
  }
  console.log('ajax_url = ' + ajax_url);

  // Ajax Request
  fetch(ajax_url)
    .then(res => res.text())
    .then(res => {
      document.querySelector('.next-articles').insertAdjacentHTML('beforebegin', res);
      document.querySelector('.articles-list .loader').classList.remove('active');
      page_number++;
      if (page_number > max_pages) {
        document.querySelector('.blog-bottom-actions').remove();
      }
    })
    .catch(err => {
      console.log(err);
      document.querySelector('.articles-list .loader').classList.remove('active');
      document.querySelector('.next-articles').innerHTML += '<p>Problème de requête. Veuillez contacter l\'administrateur du site</p>';
    });
});